import { useEnvironmentVariables } from "#app/EnvironmentProvider.tsx";
import { useSharedTranslation } from "#hooks/useSharedTranslation.ts";
import { useTracking } from "#hooks/useTracking.ts";
import { MixpanelEvent } from "#types/tracking.ts";
import { type ColorValue, Div, Inline, Link, Text, useColorSchemeValue } from "@hopper-ui/components";
import { useCallback } from "react";

export const ConversationInputUpgradeBanner = () => {
    const { tShared } = useSharedTranslation();
    const { managementAppBaseUrl } = useEnvironmentVariables();
    const { trackEvent } = useTracking();
    const linkColor = useColorSchemeValue(
        "primary",
        "upsell"
    ) as ColorValue;

    const handleClick = useCallback(() => {
        trackEvent(MixpanelEvent.ButtonClicked, {
            Location: "Conversation Input",
            Trigger: "Upgrade Banner Link"
        });
    }, [trackEvent]);

    return (
        <Div
            paddingX="core_160"
            paddingTop="core_80"
            paddingBottom="core_320"
            marginLeft="core_20"
            backgroundColor="upsell"
            borderTopRightRadius="rounded-lg"
            borderTopLeftRadius="rounded-lg"
            UNSAFE_marginBottom="-1.5rem"
        >
            <Inline gap="inline-sm">
                <Text
                    color="upsell"
                    size="sm"
                    fontWeight="body-sm-semibold"
                >
                    {tShared("upgradeBanner.outOfCredits")}
                </Text>
                <Link
                    href={`${managementAppBaseUrl}/settings/billing`}
                    size="sm"
                    color={linkColor}
                    isQuiet
                    isExternal
                    fontWeight="body-sm-semibold"
                    onClick={handleClick}
                >
                    {tShared("upgradeBanner.upgradeLink")}
                </Link>
            </Inline>
        </Div>
    );
};
